import styled, { css } from "styled-components";

interface EquipMonitoringStyleProps {
  status?: boolean;
  cardType?: "gauge" | "number";
}

export const EquipCardTitleBox = styled.div<EquipMonitoringStyleProps>`
  display: flex;
  color: ${(props) => props.theme.colors.black80};
  font-weight: 700;
  align-items: center;
  justify-content: space-between;

  // 게이지바 카드
  ${(props) =>
    props.cardType === "gauge" &&
    css`
      font-size: 1.6rem;
    `}

  // 수치 표기 카드
  ${(props) =>
    props.cardType === "number" &&
    css`
      font-size: 1.4rem;
    `}
`;

export const EquipStatusBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const EquipCardTimeBox = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-weight: 500;
  align-items: center;
  gap: 4px;

  span {
    display: inline-block;
    padding-right: 4px;
    border-right: 1px solid ${(props) => props.theme.colors.black12};
  }
`;

export const EquipCardStatus = styled.div<EquipMonitoringStyleProps>`
  display: flex;
  width: 32px;
  height: 20px;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.2rem;
  font-weight: 500;
  background: ${(props) => props.theme.colors.black8};
  border-radius: 10px;
  align-items: center;
  justify-content: center;
`;

export const EquipCardContentBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: nowrap;
  align-items: center;
`;

export const EquipCardContent = styled.div`
  display: flex;
  width: 100%;
  color: ${(props) => props.theme.colors.black60};
  font-size: 1.8rem;
  font-weight: 500;
  align-items: center;
  flex-direction: column;
  gap: 4px;

  span {
    color: ${(props) => props.theme.colors.black38};
    font-size: 1.2rem;
  }
`;

export const EquipMonitoringCard = styled.li<EquipMonitoringStyleProps>`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 20px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.field};
  justify-content: space-between;
  flex-direction: column;
  gap: 12px;

  ${EquipCardContent} + ${EquipCardContent} {
    border-left: 1px solid ${(props) => props.theme.colors.black8};
  }

  // 상태 ON
  ${(props) =>
    props.status &&
    css`
      background: ${(props) => props.theme.colors.primary100};
      box-shadow: ${(props) => props.theme.shadows.card};

      ${EquipCardTitleBox}, ${EquipCardTimeBox}, {
        color: ${(props) => props.theme.colors.white100};
      }

      ${EquipCardStatus} {
        color: ${(props) => props.theme.colors.white100};
        background: ${(props) => props.theme.colors.black30};
      }

      ${EquipCardContent} {
        color: ${(props) => props.theme.colors.white100};

        span {
          color: ${(props) => props.theme.colors.white100};
        }
      }
    `}
`;
